import React, { Component } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Meta } from '../common'
import CNCDict, { CNCDictCustomComponents } from './CustomComponents/CNCDict'

interface CompProps extends WithTranslation, RouteComponentProps {
    meta: Meta,
    http: AxiosInstance
}

export const CustomComponents = [
    ...CNCDictCustomComponents
]

class Comp extends Component<CompProps> {
    render() {
        return(
            <Switch>
              <Route path="/comp/cncdict" render={(props) => <CNCDict {...this.props}/>} />
            </Switch>
        )
    }
}

export default withTranslation()(Comp)